import {
  googleConsent,
  readConsent,
  reducedConsent,
  cleanTrackingCookies,
  analyticsPage
} from './privacy-consent.js';
// Basic consent mode: no GTM request until an explicit current-version grant.
export function createConsentTracker(
  target,
  document,
  { gtmId, reload = () => target.location.reload() }
) {
  let loaded = false,
    previous = null,
    lastPage = '';
  function command() {
    target.dataLayer = target.dataLayer || [];
    target.dataLayer.push(arguments);
  }
  command('consent', 'default', googleConsent(null));
  command('set', 'ads_data_redaction', true);
  command('set', 'url_passthrough', false);
  function update(value) {
    const record = readConsent(value);
    if (loaded && reducedConsent(previous, record)) {
      // An injected script cannot be reliably unloaded by deleting its DOM node.
      // Stop known GA properties, clear optional cookies, and reload with persisted denial.
      for (const key of Object.keys(target.google_tag_manager || {})) {
        if (/^G-[A-Z0-9]+$/.test(key)) target[`ga-disable-${key}`] = true;
      }
      cleanTrackingCookies(document, target.location.hostname);
      try {
        target.sessionStorage?.removeItem?.('idmanify:analytics-purchases');
      } catch {
        /* Optional storage may be blocked. */
      }
      target.dataLayer.length = 0;
      previous = record;
      reload();
      return;
    }
    previous = record;
    if (!record?.analytics && !record?.marketing) {
      cleanTrackingCookies(document, target.location.hostname);
      return;
    }
    const safePage = analyticsPage(
      target.location.pathname,
      target.location.origin
    );
    command('set', 'page_location', safePage.page_location);
    command('set', 'page_referrer', '');
    command('set', 'allow_google_signals', record.marketing === true);
    command(
      'set',
      'allow_ad_personalization_signals',
      record.marketing === true
    );
    command('consent', 'update', googleConsent(record));
    if (!loaded && /^GTM-[A-Z0-9]+$/.test(gtmId || '')) {
      loaded = true;
      const script = document.createElement('script');
      script.id = 'idmanify-gtm';
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
      target.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
      document.head.appendChild(script);
    }
  }
  function page(path) {
    if (!previous?.analytics) return false;
    const payload = analyticsPage(path, target.location.origin);
    if (payload.page_location === lastPage) return false;
    lastPage = payload.page_location;
    command('set', 'page_location', payload.page_location);
    command('set', 'page_referrer', '');
    target.dataLayer.push({ ecommerce: null, method: null, lead_source: null });
    target.dataLayer.push(payload);
    return true;
  }
  return { update, page };
}
